import {
  Box,
  Flex,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  useBoolean,
} from '@chakra-ui/react';
import { FiCheck, FiChevronDown } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import { getFormValues, getMetaDataFile, stepsLength } from 'redux/DataImportSlice';
import {
  PLAN_REVAMP_RADIUS_SM,
  PLAN_TEXT,
} from 'pages/PlanRevamp/PlanPageUIRevamp/planPageRevampUi';
import { fontSize, shadow } from 'styles/revampTokens';

import colors from '../dataTheme';
import { CountPill, cardStyle } from '../detailUi';
import HelpImportModal from '../HelpImportModal';

import ActionStepOne from './ActionStepOne';
import ActionStepThree from './ActionStepThree';
import ActionStepTwo from './ActionStepTwo';
import getWizardStepLabels from './wizardSteps';
import ActionStepSyncOptions from './ActionStepSyncOptions';
import DataStepsForm from './DataSteps/DataStepsForm';

const ActionCreateForm = ({ setactionCreate }: any) => {
  const dispatch: any = useDispatch();
  const { modelId } = useParams();
  const [helpModalSeleceted, setHelpModalSeleceted] = useBoolean(false);
  const getFormValue = useSelector(getFormValues);
  const [steps, setSteps] = useState([1, 2, 3]);
  const activeActionStep = useSelector((state: any) => state.dataImportSlice.actionSteps);

  useEffect(() => {
    dispatch(getMetaDataFile(modelId));
  }, [modelId]);

  useEffect(() => {
    if (getFormValue.dataType === '1') {
      // Dimension imports always have 4 steps: name → target → properties → removal config
      setSteps([1, 2, 3, 4]);
    }
  }, [getFormValue.dataType === '1', activeActionStep]);

  useEffect(() => {
    if (getFormValue.dataType === '2' || getFormValue.dataType === '3') {
      setSteps([1, 2, 3, 4, 5, 6]);
    }
  }, [getFormValue.dataType, activeActionStep]);
  useEffect(() => {
    if (
      (getFormValue.dataType === '2' || getFormValue.dataType === '3') &&
      getFormValue?.dataPeriod === '1'
    ) {
      setSteps([1, 2, 3, 4, 5, 6]);
    }
  }, [getFormValue.dataType, getFormValue?.dataPeriod, activeActionStep]);

  useEffect(() => {
    if (
      (getFormValue.dataType === '2' || getFormValue.dataType === '3') &&
      getFormValue?.dataPeriod === '2'
    ) {
      setSteps([1, 2, 3, 4, 5, 6, 7]);
    }
  }, [getFormValue.dataType, getFormValue?.dataPeriod, activeActionStep]);

  useEffect(() => {
    if (
      (getFormValue.dataType === '2' || getFormValue.dataType === '3') &&
      getFormValue?.dataPeriod === '2' &&
      (getFormValue?.selectedTimePeriod === 'row' || getFormValue?.selectedTimePeriod === 'column')
    ) {
      setSteps([1, 2, 3, 4, 5, 6, 7]);
    }
  }, [
    getFormValue.dataType,
    getFormValue?.dataPeriod,
    activeActionStep,
    getFormValue.selectedTimePeriod,
  ]);

  useEffect(() => {
    if (
      (getFormValue.dataType === '2' || getFormValue.dataType === '3') &&
      getFormValue?.dataPeriod === '1' &&
      getFormValue?.multipleIndicatorsType === 'row' &&
      getFormValue?.importIndicatorType === '2'
    ) {
      setSteps([1, 2, 3, 4, 5, 6, 7, 8]);
    }
  }, [
    getFormValue.dataType,
    getFormValue?.dataPeriod,
    getFormValue?.multipleIndicatorsType,
    getFormValue?.importIndicatorType,
    activeActionStep,
  ]);

  useEffect(() => {
    if (
      (getFormValue.dataType === '2' || getFormValue.dataType === '3') &&
      getFormValue?.dataPeriod === '1' &&
      getFormValue?.multipleIndicatorsType === 'column' &&
      getFormValue?.importIndicatorType === '2'
    ) {
      setSteps([1, 2, 3, 4, 5, 6, 7]);
    }
  }, [
    getFormValue.dataType,
    getFormValue?.dataPeriod,
    getFormValue?.multipleIndicatorsType,
    getFormValue?.importIndicatorType,
    activeActionStep,
  ]);

  useEffect(() => {
    if (
      (getFormValue.dataType === '2' || getFormValue.dataType === '3') &&
      getFormValue?.dataPeriod === '2' &&
      getFormValue?.selectedTimePeriod === 'row' &&
      getFormValue?.multipleIndicatorsType === 'row' &&
      getFormValue?.importIndicatorType === '2'
    ) {
      setSteps([1, 2, 3, 4, 5, 6, 7, 8, 9]);
    }
  }, [
    getFormValue.dataType,
    getFormValue?.dataPeriod,
    getFormValue?.selectedTimePeriod,
    getFormValue?.multipleIndicatorsType,
    getFormValue?.importIndicatorType,
    activeActionStep,
  ]);
  useEffect(() => {
    if (
      (getFormValue.dataType === '2' || getFormValue.dataType === '3') &&
      getFormValue?.dataPeriod === '2' &&
      getFormValue?.selectedTimePeriod === 'column' &&
      getFormValue?.multipleIndicatorsType === 'row' &&
      getFormValue?.importIndicatorType === '2'
    ) {
      setSteps([1, 2, 3, 4, 5, 6, 7, 8]);
    }
  }, [
    getFormValue.dataType,
    getFormValue?.dataPeriod,
    getFormValue?.selectedTimePeriod,
    getFormValue?.multipleIndicatorsType,
    getFormValue?.importIndicatorType,
    activeActionStep,
  ]);

  useEffect(() => {
    if (
      (getFormValue.dataType === '2' || getFormValue.dataType === '3') &&
      getFormValue?.dataPeriod === '2' &&
      getFormValue?.multipleIndicatorsType === 'column' &&
      getFormValue?.importIndicatorType === '2'
    ) {
      setSteps([1, 2, 3, 4, 5, 6, 7, 8]);
    }
  }, [
    getFormValue.dataType,
    getFormValue?.dataPeriod,
    getFormValue?.multipleIndicatorsType,
    getFormValue?.importIndicatorType,
    activeActionStep,
  ]);

  useEffect(() => {
    dispatch(stepsLength(steps.length));
  }, [steps]);

  // Pad with generic names for any step the user has not reached the branching choice for yet.
  const stepLabels = useMemo(() => {
    const named = getWizardStepLabels(getFormValue);
    return steps.map((_, index) => named[index] ?? `Step ${index + 1}`);
  }, [getFormValue, steps.length]);

  return (
    <Flex direction='column' h='100%' minH={0} {...cardStyle} overflow='hidden'>
      <Box px={4} pt={3} pb={3} flexShrink={0}>
        <Popover placement='bottom-start' isLazy>
          <PopoverTrigger>
            <Flex
              as='button'
              type='button'
              alignItems='center'
              gap={2}
              maxW='100%'
              aria-label='Show all steps'
            >
              <CountPill>{`Step ${Math.min(activeActionStep + 1, steps.length)} of ${
                steps.length
              }`}</CountPill>
              <Text {...PLAN_TEXT.bodyMedium} color={colors.textDark} noOfLines={1}>
                {stepLabels[activeActionStep]}
              </Text>
              <FiChevronDown size={14} color={colors.textSecondary} />
            </Flex>
          </PopoverTrigger>
          <PopoverContent
            w='240px'
            border='1px solid'
            borderColor={colors.border}
            borderRadius={PLAN_REVAMP_RADIUS_SM}
            boxShadow={shadow.overlay}
            _focusVisible={{ boxShadow: shadow.overlay }}
          >
            <PopoverBody p={2}>
              {stepLabels.map((label, index) => {
                const isDone = index < activeActionStep;
                const isCurrent = index === activeActionStep;
                return (
                  <Flex key={`${label}-${index}`} alignItems='center' gap={3} px={2} py='7px'>
                    <Flex
                      w='18px'
                      h='18px'
                      flexShrink={0}
                      alignItems='center'
                      justifyContent='center'
                      borderRadius='full'
                      border='1px solid'
                      borderColor={isDone || isCurrent ? colors.primary : colors.border}
                      bg={isDone ? colors.primary : colors.surface}
                    >
                      {isDone && <FiCheck size={11} strokeWidth={3} color={colors.white} />}
                      {isCurrent && <Box w='6px' h='6px' borderRadius='full' bg={colors.primary} />}
                    </Flex>
                    <Text
                      {...PLAN_TEXT.body}
                      fontSize={fontSize.body}
                      fontWeight={isCurrent ? 600 : 400}
                      color={isDone || isCurrent ? colors.textDark : colors.textSecondary}
                    >
                      {label}
                    </Text>
                  </Flex>
                );
              })}
            </PopoverBody>
          </PopoverContent>
        </Popover>

        {/* Step count changes with the user's choices, so progress is a segmented bar
            rather than a fixed list of labelled steps. */}
        <Flex gap='4px' mt={3}>
          {steps.map((step, index) => (
            <Box
              key={step}
              flex={1}
              h='4px'
              borderRadius='full'
              bg={index <= activeActionStep ? colors.primary : colors.border}
              transition='background 0.2s ease'
            />
          ))}
        </Flex>
      </Box>

      <Box
        flex={1}
        minH={0}
        overflowY='auto'
        className='scroll'
        px={4}
        py={4}
        borderTop='1px solid'
        borderColor={colors.border}
      >
        {activeActionStep === 0 ? (
          <ActionStepOne
            setHelpModalSeleceted={setHelpModalSeleceted}
            setactionCreate={setactionCreate}
          />
        ) : activeActionStep === 1 ? (
          <ActionStepTwo setHelpModalSeleceted={setHelpModalSeleceted} />
        ) : getFormValue?.dataType === '1' && activeActionStep === 2 ? (
          // Step 3 (dimension): map file columns to dimension properties
          <ActionStepThree />
        ) : getFormValue?.dataType === '1' && activeActionStep === 3 ? (
          // Step 4 (dimension): sync options — remove missing items config, then run
          <ActionStepSyncOptions
            actionType='dimension'
            setHelpModalSeleceted={setHelpModalSeleceted}
          />
        ) : (
          <DataStepsForm setHelpModalSeleceted={setHelpModalSeleceted} />
        )}
        <HelpImportModal
          setHelpModalSeleceted={setHelpModalSeleceted}
          helpModalSeleceted={helpModalSeleceted}
        />
      </Box>
    </Flex>
  );
};

export default ActionCreateForm;
